import React from 'react';
import { CtaButton } from '../CtaButton';
import { ProductImage } from '../ProductImage';
import { PriceBlock } from '../PriceBlock';
import { CORE_PROMISE, heroPillars } from '../../data/salesContent';
export function HeroSection() {
  return <header className="bg-ink px-5 pb-20 pt-12 md:pb-28 md:pt-16" data-id="element-139" data-mp="218jgmanfu3l4">
      <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[1.05fr_1fr]" data-id="element-140" data-mp="1x7psbg632mrp">
        <div className="text-center lg:text-left" data-id="element-141" data-mp="1saputtnausc7">
          <p className="inline-block rounded-full border border-gold/40 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-gold md:text-sm" data-id="element-142" data-mp="1sbhhug2tzhqv">
            Sistema profesional para instructores
          </p>
          <p className="mt-6 font-display text-base font-extrabold uppercase tracking-[0.15em] text-neutral-300 md:text-lg" data-id="element-143" data-mp="1dl1sqq7anpnf">
            Primeros Auxilios para Instructores™
          </p>
          <h1 className="mt-4 font-display text-4xl font-black leading-[1.1] text-cream md:text-6xl" data-id="element-144" data-mp="14k3nk4l4dc39">
            Dejá de preparar cada capacitación de primeros auxilios <span className="text-gold" data-id="element-145" data-mp="31mkxnmqguaxn">desde cero.</span>
          </h1>
          <p className="mt-6 text-xl leading-relaxed text-neutral-300 md:text-2xl" data-id="element-146" data-mp="36f48wd1oktza">
            Tené en un solo sistema qué enseñar, cómo explicarlo, cómo hacerlo practicar y cómo evaluar a tus alumnos.
          </p>
          <p className="mt-6 font-display text-lg font-extrabold uppercase tracking-wide text-cream md:text-xl" data-id="element-147" data-mp="2wpuhkzenvfc8">
            3 volúmenes + 5 bonos prácticos
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-3 lg:justify-start" data-id="element-148" data-mp="3pe8fzg9nwdob">
            {heroPillars.map(({
            label,
            icon: Icon
          }) => <li key={label} className="flex items-center gap-2 text-sm font-semibold text-neutral-200 md:text-base" data-id="element-149" data-mp="3bg1rgqqlrq1b">
                <Icon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-150" data-mp="1zys8047h4y00" />
                {label}
              </li>)}
          </ul>
        </div>
        <ProductImage className="mx-auto w-full max-w-2xl" data-id="element-151" data-mp="24yn36jya89qv" />
      </div>

      <div className="mx-auto mt-14 flex max-w-2xl flex-col items-center text-center" data-id="element-152" data-mp="ahwomc6q8o9v">
        <p className="font-display text-xl font-extrabold uppercase tracking-wide text-gold md:text-2xl" data-id="element-153" data-mp="5i1ywbyou4qe">{CORE_PROMISE}</p>
        <div className="my-8 h-px w-full bg-ink-line" aria-hidden="true" data-id="element-154" data-mp="qscrlccljj9" />
        <PriceBlock lead="Hoy por" data-id="element-155" data-mp="3sw5xexbtnf20" />
        <div className="mt-8 w-full" data-id="element-156" data-mp="3sv4mcsut2ska">
          <CtaButton note="Acceso a los 3 volúmenes + 5 bonos" data-id="element-157" data-mp="3nwjkyq3ti2u9">Quiero el sistema completo</CtaButton>
        </div>
      </div>
    </header>;
}